import { RoutesProvider } from '@folklore/routes';
import { ConsentProvider } from '@micromag/core/contexts';
import { IntlProvider } from '@micromag/intl';
import Cookies from 'js-cookie';
import { useMemo } from 'react';
import { Router } from 'wouter';

import { AnalyticsProvider } from '../contexts/AnalyticsContext';
import { ModalProvider } from '../contexts/ModalContext';
import defaultMicromags from '../micromags';
import Routes from './Routes';

import '../styles/styles.css';

interface IntlProps {
    locale?: string;
    messages?: Record<string, Record<string, string>> | Record<string, string>;
}

interface AppProps {
    intl?: IntlProps | null;
    routes?: Record<string, string>;
    googleAnalyticsIds?: Array<string>;
    micromags?: MicromagItem[] | null;
}

function App({ intl = null, routes, micromags = defaultMicromags, googleAnalyticsIds }: AppProps) {
    const { locale = 'fr', messages = null } = intl || {};
    const finalMessages = messages !== null && messages[locale] ? messages[locale] : messages;

    // const consent = useMemo(() => {
    //     const axeptioCookie = Cookies.get('axeptio_cookies');
    //     let axeptioData = null;
    //     try {
    //         axeptioData =
    //             axeptioCookie !== null && axeptioCookie.length
    //                 ? JSON.parse(decodeURIComponent(axeptioCookie))
    //                 : null;
    //     } catch (e) {
    //         console.log(axeptioCookie);
    //         console.error('Error parsing axeptio_cookies:', e);
    //     }
    //     const axeptioConsent =
    //         axeptioData !== null && typeof axeptioData['$$googleConsentMode'] !== 'undefined'
    //             ? axeptioData['$$googleConsentMode']
    //             : null;
    //     return axeptioConsent;
    // }, []);

    // console.log(consent);

    return (
        <IntlProvider locale={locale} messages={finalMessages || {}}>
            {/* <ConsentProvider consent={consent}> */}
                <ModalProvider>
                    <AnalyticsProvider googleAnalyticsIds={googleAnalyticsIds || null}>
                        <Router>
                            <RoutesProvider routes={routes}>
                                <Routes micromags={micromags} />
                            </RoutesProvider>
                        </Router>
                    </AnalyticsProvider>
                </ModalProvider>
            {/* </ConsentProvider> */}
        </IntlProvider>
    );
}

export default App;
